module.exports = __webpack_public_path__ + "img/headEmpty.81e2ee06.png";